import { writable } from 'svelte/store';
function getLocalStorage() {
    const pixelMatrix = localStorage.getItem('pixelMatrix');
    if (pixelMatrix) {
        return JSON.parse(pixelMatrix);
    }
    return createPixelMatrix();
}
function setLocalStorage(pixels) {
    localStorage.setItem('pixelMatrix', JSON.stringify(pixels));
    return pixels;
}
function createPixelMatrix() {
    const pixels = [];
    for (let i = 0; i < 16; i++) {
        pixels[i] = [];
        for (let j = 0; j < 16; j++) {
            pixels[i][j] = { r: 255, g: 255, b: 255, a: 0 };
        }
    }
    return pixels;
}
function createPixelStore() {
    const { subscribe, set, update } = writable(getLocalStorage());
    return {
        subscribe,
        update: (x, y, pixel) => update(pixels => {
            pixels[y][x] = pixel;
            return setLocalStorage(pixels);
        }),
        clear: () => update(() => {
            const pixels = createPixelMatrix();
            return setLocalStorage(pixels);
        })
    };
}
export const PixelStore = createPixelStore();
